<script lang="ts">
	import LogoIcon from 'assets/svg/cryptomarketcapLogo.svg?component';
	import LogoIconDark from 'assets/svg/cryptomarketcapLogoWhite.svg?component';
	import MobileMenu from './MobileMenu/MobileMenu.svelte';
	import Navigation from './Navigation/Navigation.svelte';
	import LocaleLink from 'components/LocaleLink/LocaleLink.svelte';

	export let dark = false;
</script>

<header class="header">
	<div class="container">
		<LocaleLink href="/" label="CryptoMarketCap.com">
			<span class="logo-link">
				{#if dark}
					<LogoIconDark width={200} class="app-logo" />
				{:else}
					<LogoIcon width={200} class="app-logo" />
				{/if}
			</span>
		</LocaleLink>

		<nav class="navigation">
			<Navigation darkTheme={dark} />
			<MobileMenu darkTheme={dark} />
		</nav>
	</div>
</header>

{#if dark}
	<style lang="scss">
		@import 'src/styles/colors';
		body {
			background: $color-black;
			color: $color-white;
		}
	</style>
{:else}
	<style lang="scss">
		@import 'src/styles/colors';
		body {
			background: $color-bg-lightGrey;
			color: $color-black;
		}
	</style>
{/if}

<style lang="scss">
	@import 'header';
</style>
